import { jsx as r, jsxs as l } from "react/jsx-runtime";
import * as v from "react";
import { cn as d } from "../../../lib/utils.js";
const p = (t) => {
  const a = [
    "bg-lpr-teal/15 text-lpr-teal dark:bg-lpr-gold/15 dark:text-lpr-gold",
    "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400",
    "bg-sky-100 text-sky-700 dark:bg-sky-900/30 dark:text-sky-400",
    "bg-violet-100 text-violet-700 dark:bg-violet-900/30 dark:text-violet-400",
    "bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400",
    "bg-rose-100 text-rose-700 dark:bg-rose-900/30 dark:text-rose-400"
  ], c = t.split("").reduce((s, n) => s + n.charCodeAt(0), 0) % a.length;
  return a[c];
}, u = (t) => {
  switch (t) {
    case "green":
      return "bg-emerald-100 dark:bg-emerald-900/40";
    case "blue":
      return "bg-sky-100 dark:bg-sky-900/40";
    case "red":
      return "bg-rose-100 dark:bg-rose-900/40";
    case "purple":
      return "bg-violet-100 dark:bg-violet-900/40";
    case "yellow":
      return "bg-amber-100 dark:bg-amber-900/40";
    default:
      return "bg-[var(--bg-muted)]";
  }
}, b = (t) => {
  switch (t) {
    case "green":
      return "text-emerald-600 dark:text-emerald-400";
    case "blue":
      return "text-sky-600 dark:text-sky-400";
    case "red":
      return "text-rose-600 dark:text-rose-400";
    case "purple":
      return "text-violet-600 dark:text-violet-400";
    case "yellow":
      return "text-amber-600 dark:text-amber-400";
    default:
      return "text-[var(--text-secondary)]";
  }
}, h = v.forwardRef(({ items: t, className: a, compact: c = !1, ...s }, n) => r("div", { ref: n, className: d("rounded-2xl border border-[var(--border-color)] bg-[var(--bg-surface)] divide-y divide-[var(--border-color)]", a), ...s, children: t.map((e) => {
  var i, x, m;
  const o = e.icon, g = ((m = (x = (i = e.user) == null ? void 0 : i.name) == null ? void 0 : x.charAt(0)) == null ? void 0 : m.toUpperCase()) ?? "?";
  return l("div", { className: "flex items-start gap-3 px-4 py-3 hover:bg-[var(--bg-muted)] transition-colors", children: [e.user ? r("div", { className: d("flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-semibold", p(e.user.name)), children: e.user.avatar ? r("img", { src: e.user.avatar, alt: e.user.name, className: "h-full w-full rounded-full object-cover" }) : g }) : o ? r("div", { className: d("flex h-8 w-8 shrink-0 items-center justify-center rounded-full", u(e.iconColor)), children: r(o, { className: d("h-4 w-4", b(e.iconColor)) }) }) : r("div", { className: "flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[var(--bg-muted)]", children: r("div", { className: "h-2 w-2 rounded-full bg-[var(--text-secondary)]" }) }), l("div", { className: "flex-1 min-w-0", children: [l("p", { className: "text-sm text-[var(--text-primary)] leading-snug", children: [e.user && l("span", { className: "font-semibold", children: [e.user.name, " "] }), e.title] }), e.description && !c && r("p", { className: "text-xs text-[var(--text-secondary)] mt-0.5 leading-relaxed", children: e.description }), e.metadata && r("div", { className: "mt-2", children: e.metadata })] }), e.timestamp && r("span", { className: "shrink-0 text-xs text-[var(--text-secondary)] pt-0.5", children: e.timestamp })] }, e.id);
}) }));
h.displayName = "ActivityFeed";
const y = ({ icon: t, iconColor: a, title: c, timestamp: s }) => l("div", { className: "flex items-center justify-between gap-2 py-2", children: [l("div", { className: "flex items-center gap-3", children: [r("div", { className: d("flex h-8 w-8 items-center justify-center rounded-full border border-border-color", u(a)), children: t && r(t, { className: d("h-4 w-4", b(a)) }) }), r("p", { className: "text-sm text-text-primary truncate", children: c })] }), s && r("span", { className: "text-xs text-text-secondary/60 whitespace-nowrap", children: s })] });
export {
  h as ActivityFeed,
  y as CompactActivityItem
};
//# sourceMappingURL=ActivityFeed.js.map
